import {Icon, MenuDivider} from '@blueprintjs/core'
import {Chip} from '@material-ui/core'
import {Subtitles} from '@material-ui/icons'
import {
	CatalogItemRelationshipsContextMenuItem, BuilderCardLoader, CatalogColumnsSliderContextMenuItem, CatalogItemPreviewMenuItem, CatalogItemPreviewMenuItemProps, ChooseSubgroupSubmenu,
	ChooseSwatchesSubmenuItem, ClearHierarchyMenuItem, ContextMenuItem, DefaultCatalogContextMenuItems, GroupByContextMenuItems, GroupByDropdownStore, GroupByDropdownStoreContext, GroupByGroupStoreContext, GroupSwatch,
	NewCatalogItemSubmenu, OpenInC8MenuItem, OpenInWorkspaceMenuItem, useGroupByGroupStore, GroupSwatchesSizeSlider, ContextMenuItemProps, GroupByFieldMenuItems, GroupByContextMenuItemContentsForLevel, useGroupByDropdownStore, FilterForCatalogFieldValue, GroupByThisCatalogFieldMenuItem, useFilterStore, useVipLocalStore
} from '@modules'
import {GroupByGrouping, GroupTitleConfig, useCatalog} from '@stores/index'
import {Fragment, logJS, observer, React, toJS, useLocalStore} from '@api'
import {icons} from '@stores/ui'
import {VipLocalStore} from '@modules'
import {NumberBadge} from 'centric-ui-components'
import * as css from './GroupByGroupContextMenu.css'

interface MyProps {
  showGroupTitle?: boolean

	/**
	 * Change 'some group' to 'new group' instead of raw group by list
	 */
	isSpecificGroup?: boolean
}

/**
 * Top-level context menu for a {@see GroupByGroupStore}
 */
export const GroupByGroupContextMenu: React.FunctionComponent<MyProps> & { css?: typeof css } = observer<MyProps>(function GroupByGroupContextMenu({showGroupTitle, isSpecificGroup}) {
	const {grouping, grouping: {level, mySubtitleFields}, parentStore} = useGroupByGroupStore(),
		groupByDropdownStore = useVipLocalStore((ws) => new GroupByDropdownStore(ws, {level: level, group: grouping}, 'contextMenu'))

	return <Fragment>
		<GroupByDropdownStoreContext.Provider value={groupByDropdownStore}>

			{parentStore &&
			 <GroupByGroupStoreContext.Provider value={parentStore}>
				 <GroupByGroupContextMenu isSpecificGroup/>
			 </GroupByGroupStoreContext.Provider>}

			{(showGroupTitle || isSpecificGroup) && <GroupTitleSubmenu contents={isSpecificGroup ? 'actions' : 'card'}/>}
			<MyGroupSubtitleMenuItems />
			{!_.isEmpty(mySubtitleFields) && <FilterThisGroupCombinationMenuItem dividerBefore dividerAfter/>}

			{!isSpecificGroup &&
			 <Fragment>
			 {/*{false && !(contextMenu.store instanceof GroupBySwatchesStore) &&  <GroupSwatchesSizeSlider dividerBefore />}*/}
				 <GroupSwatchesSizeSlider dividerBefore/>
				 {!parentStore && <CatalogColumnsSliderContextMenuItem dividerBefore dividerAfter/>}
				 <MenuDivider/>
				 <ManageGroupByHierarchyMenuItem />
				 <MenuDivider/>
				 <GroupByGroupActiveContextMenuItems/>

				 <DefaultCatalogContextMenuItems hideClearHierarchy hideGroupBy hideNewItem/>
			 </Fragment>}
		</GroupByDropdownStoreContext.Provider>
	</Fragment>
});

export const ManageGroupByHierarchyMenuItem = observer(function ManageGroupByHierarchyMenuItem() {
    return (
	    <ContextMenuItem icon={icons.manageHierarchy} text={`Group By`}>
		    <ClearHierarchyMenuItem dividerAfter/>
		    <GroupByContextMenuItems/>
	    </ContextMenuItem>
    )
})
GroupByGroupContextMenu.defaultProps = {
	showGroupTitle: true
}

GroupByGroupContextMenu.css = css

const FilterThisGroupCombinationMenuItem = observer<ContextMenuItemProps>(function FilterThisGroupCombinationMenuItem(props) {
    const {catalog: {filter}, toggleExcludeThisGroupCombination, isThisGroupExplicitlyExcluded} = useGroupByGroupStore(),
	    {state: {extraTerms}} = filter

    return (<Fragment>
      <ContextMenuItem {..._.pick(props, 'dividerBefore')} text='Exclude this Group' shouldDismissPopover icon={isThisGroupExplicitlyExcluded ? 'tick' : 'remove-column'} active={isThisGroupExplicitlyExcluded} onClick={toggleExcludeThisGroupCombination} />
	    {!_.isEmpty(extraTerms) && <ContextMenuItem {..._.pick(props, 'dividerAfter')} text='Excluded Groups' icon='filter-remove' >
		    <ManageExtraTermsMenuItems/>
	    </ContextMenuItem>}
    </Fragment>)
});

export const ManageExtraTermsMenuItems = observer(function ManageExtraTermsMenuItems() {
    const {state, state: {extraTerms}} = useFilterStore()

    return (<Fragment>
	    <ContextMenuItem dividerAfter icon='clean' text='Clear Exclusions' onClick={() => state.extraTerms = []}/>
	    {extraTerms.map(t => <ContextMenuItem key={t.id} icon='tick' text={t.store.fullTitle} onClick={t.store.toggleExcludeThisGroupCombination}/>)}
    </Fragment>)
})

const MyGroupSubtitleMenuItems = observer(function MyGroupSubtitleMenuItems() {
	const {catalog, catalog: {settings: {viewMode}, vlp}, stores,
			props: {info, level}, grouping, mySubtitleFieldsWithValues} = useGroupByGroupStore()

	return <Fragment>
		{mySubtitleFieldsWithValues.map(({field, value, label}, i) => {
			const vlpField = vlp.hierarchy.parseHierarchyGroup(field),
				dropdownStore = new GroupByDropdownStore(stores, { group: grouping, level }, 'subtitleContextMenu'),
				f = catalog._fieldByName[field],
				fieldLabel = catalog.labelForFieldName_currentCatalog(field)
			// logJS({field, value, label, vlpField})

			return (
				<ContextMenuItem key={i}
				                 className={css.subtitleMenuItem}
				                 icon={<div className={css.subtitleIcon}>S<sub>{i + 1}</sub></div>}
				                 text={<div className={css.labelAndValue}>
					                 {f && <label>{fieldLabel}:</label>}
					                 <span className={css.value}>{f?.def?.prefix}{label}</span>
					                 {false && f && <Chip className={css.fieldLabelChip} label={fieldLabel}/>}
				                 </div>}>
					{viewMode == 'card' && _.has(catalog.cardView, field) && <Fragment>
						<ContextMenuItem dividerBefore dividerAfter icon={catalog.cardView[field] ? 'tick' : 'blank'} text={`Show on Cards`} onClick={() => catalog.toggleCardField(f)}/>
					</Fragment>}

					{!vlpField &&
					 <Fragment>
						<ContextMenuItem icon={icons.changeGroup} text={`Manage Subtitle...`}>
							<GroupByDropdownStoreContext.Provider value={dropdownStore}>
								{/*<GroupByGroupContextMenu isSpecificGroup/>*/}
								<GroupByFieldMenuItems />
							</GroupByDropdownStoreContext.Provider>
						</ContextMenuItem>
						<ContextMenuItem icon='trash' text='Remove Subtitle' onClick={grouping.onRemoveSubtitleField(field)}/>
						<MenuDivider/>
					</Fragment>}

					<FilterSubtitleMenuItems field={field} value={value} title={label}/>
				</ContextMenuItem>
			)
		})}
	</Fragment>
});

export const FilterSubtitleMenuItems = observer<{field: string, value?: any, title?: any}>(function FilterSubtitleMenuItems({field, value, title}) {
	const {props: {info}} = useGroupByGroupStore()

	return <FilterForCatalogFieldValue field={field} value={value} title={title ?? info?.title} />
})

const GroupBuilderCardTopHit = observer(function GroupBuilderCardTopHit() {
	const {esInfo} = useGroupByGroupStore()
	return <GroupBuilderCard data={esInfo} />
})

const GroupBuilderCard = observer<{data}>(function GroupBuilderCard({data}) {
	const {catalog: {idFor}, grouping: {fieldDefinition}} = useGroupByGroupStore()
	return (
		<BuilderCardLoader
			className={css.builderCard}
			hideButtons
			isPopover
			levelOfDetail={1}
			field={fieldDefinition}
			nested={{field: fieldDefinition, data}}
			id={idFor(data)}/>
	)
})

export const MyGroupSwatch = observer(function MyGroupSwatch() {
	const {grouping: {level}} = useGroupByGroupStore()

	//<div className={css.noImageSpacer}/>
	return <GroupSwatch borderIfObjectFitCover emptyContents={<Icon className={css.noImageSpacer} icon={level == 0 ? 'header-one' : level === 1 ? 'header-two' : 'header'} />}/>
})

/**
 *
 */
const GroupTitleSubmenu = observer<{contents?: 'actions' | 'card'}>(function GroupTitleSubmenu({contents}) {
	const {catalog, groupLabel, esInfo, grouping, grouping: {fieldDefinition : f, associatedWorkspace, groupTitle}} = useGroupByGroupStore(),
		id = catalog.idFor(esInfo)

	const GroupTitleMenuLabel = <div className={css.groupTitle}>
		<MyGroupSwatch/>
		<div className={css.labelAndValue}>
			{f && <label>{catalog.labelForField(f)}:</label>}
			<span className={css.value}>{f?.def?.prefix}{groupLabel}</span>
			{false && f && <Chip className={css.fieldLabelChip} label={catalog.labelForField(f)} />}
		</div>
	</div>

	if (contents === 'actions') {
		return (
			<ContextMenuItem text={GroupTitleMenuLabel} icon={null} className={css.groupTitleMenuItem}>
				{f?.esIndex && <Fragment>
					<GroupBySpecInlinePreviewMenuItems/>
					<MenuDivider/>
				</Fragment>}
				<GroupByGroupActiveContextMenuItems/>
			</ContextMenuItem>
		)
	} else {
		return (
			<Fragment>
				{esInfo ? <GroupBySpecInlineListPreviewMenuItems/>
				        : <ContextMenuItem className={css.groupTitleMenuItem} text={GroupTitleMenuLabel}>
					 {esInfo &&
					  <Fragment>
						  <ContextMenuItem text='Preview' icon={icons.previewCard}>
							  <GroupBuilderCardTopHit/>
						  </ContextMenuItem>
						  {associatedWorkspace && esInfo && <Fragment>
							  <MenuDivider/>
							  <OpenInWorkspaceMenuItem workspace={associatedWorkspace} id={id}/>
							  <OpenInC8MenuItem id={catalog.idFor(esInfo)}/>
						  </Fragment>}
					  </Fragment>}
					 <GroupByContextMenuItemContentsForLevel level={grouping.level}/>
					 <GroupSubtitlesContextMenuItem group={grouping}/>
					 <MenuDivider/>
					 <FilterGroupMenuItems/>
					 <MenuDivider/>
					 <ChooseSubgroupSubmenu/>
					 <ChooseSwatchesSubmenuItem/>

				 </ContextMenuItem>}
			</Fragment>)
	}
})

export const GroupSubtitlesContextMenuItem = observer<{group: GroupByGrouping}>(function GroupSubtitlesContextMenuItem({group}) {
	if (group.isCatalogItemsGrouping) return null

	const groupByDropdownStore = useVipLocalStore((ws) => new GroupByDropdownStore(ws, {level: group.level, group}, 'subtitleContextMenu'))

	const {mySubtitleFieldsNonHierarchy} = group

	return (
		<GroupByDropdownStoreContext.Provider value={groupByDropdownStore}>
			<ContextMenuItem icon={<Subtitles/>} text={`${_.isEmpty(mySubtitleFieldsNonHierarchy) ? 'Add' : 'Manage'} Subtitles${!_.isEmpty(mySubtitleFieldsNonHierarchy) ? ` (${mySubtitleFieldsNonHierarchy.length})` : ''}...`}>
				<GroupByFieldMenuItems/>
			</ContextMenuItem>
		</GroupByDropdownStoreContext.Provider>
	)
})

export const ExistingSubtitleField = observer<{ field: GroupTitleConfig}>(function ExistingSubtitleField({field}) {
	const {grouping, catalog} = useGroupByDropdownStore()
	return <ContextMenuItem text={catalog.labelForFieldName_currentCatalog(field.field)}
	                        onClick={() => grouping.toggleSubtitleField(field.field)} />
})

const FilterGroupMenuItems = observer(function FilterGroupMenuItems() {
	const {catalog: {filter}, grouping: {fieldDefinition, groupName, groupTitle, hierarchyTypeGroup, hierarchyType}, props: {info, info: {title}}, navigateTo} = useGroupByGroupStore()

  if (hierarchyTypeGroup) {
    return <ContextMenuItem text={`Go to ${groupTitle} '${title}'`}
                            icon={icons.goToSeason}
                            onClick={() => navigateTo(groupName)}/>
  }

  const value = info.keys[fieldDefinition.field],
    filterGroup = filter.groupFor(fieldDefinition.field),
		{selected, excluded} = filterGroup,
		isSelected = selected?.has(value), isExcluded = excluded?.has(value)
		// console.log(toJS({value, isSelected}, {recurseEverything: true}))

	return !_.isEmpty(filterGroup) && <Fragment>
		<ContextMenuItem icon={isSelected ? 'tick' : 'blank'}
		                 text={`Filter for '${title}'`}
		                 onClick={() => filter.toggleFilter({key: fieldDefinition.field, value})}/>
		<ContextMenuItem icon={isExcluded ? 'tick' : 'blank'}
		                 text={`Exclude '${title}'`}
		                 onClick={() => filter.toggleFilter({key: fieldDefinition.field, exclude: true, value})}/>
		</Fragment>
})

const GroupBySpecInlineListPreviewMenuItems = observer(function GroupBySpecInlineListPreviewMenuItems() {
	const store = useGroupByGroupStore(),
		{strings, catalog, props: {info: {keys, title, aggs: {esItem: {hits: {hits}}}}}, grouping: {esIndex, associatedWorkspace, fieldDefinition, esFieldRoot}} = store,
		groupValue = keys[fieldDefinition.field],


		flattened = _.uniqBy(
			_.flatMap(hits.map(({_source}, i) => {
			let item = _.get(_source, esFieldRoot)

			// This can be a field like style.colorways so catalog item may have multiple results
			// Since we're already inside of some specific group (usually done by name) we can narrow down the array further if needed

			if (_.isArray(item)) {
				item = item.filter(v => _.get(v, fieldDefinition.group?.field ?? 'name') === groupValue)
			} else {
				item = [item]
			}

			return item
		})), catalog.idFor),
		specMenuItems = flattened.map((v, j) => <SpecContextMenuItem data={v} key={j} workspace={associatedWorkspace} field={fieldDefinition} />)

	// console.log({hits, flattened, specMenuItems})
	return <Fragment>
		{specMenuItems.length == 0
		 ? <ContextMenuItem text={strings.noValue}/>
		 : specMenuItems.length == 1
		   ? specMenuItems[0]
		   :
		   <ContextMenuItem
			   className={css.titleWithCountMenuHeader}
			   text={
				   <div className={css.titleAndCount}>
					   <span className={css.title}>{title}</span> {/*groupTitle}:<span className={css.groupValue}>{title}</span></span>*/}
					   <NumberBadge value={specMenuItems.length} className={css.count}/>
				   </div>}>
			   <div className={css.inlinePreviews}>
				   {specMenuItems}
			   </div>
		   </ContextMenuItem>}
	</Fragment>
})

export const SpecContextMenuItem = observer<CatalogItemPreviewMenuItemProps & ContextMenuItemProps>((props) => {
	const {field, workspace} = props,
		catalog = useCatalog(),
		data = _.omit(props.data, '__parent'),
		id = catalog.idFor(data)

	return (<CatalogItemPreviewMenuItem menuLook {...props} data={data}>
		{/*<InlineBuilderCardMenuItem children={null} />*/}

		<ContextMenuItem text='Preview' icon={icons.previewCard} noSubmenuPadding>
			<BuilderCardLoader id={id} field={field} levelOfDetail={1} hideButtons isPopover imageSource='images'/>
		</ContextMenuItem>
		{field && <Fragment>
			<MenuDivider/>
			<CatalogItemRelationshipsContextMenuItem data={data} index={field.esIndex} field={field}/>
		</Fragment>}

		{workspace && <Fragment>
			<MenuDivider/>
			<OpenInWorkspaceMenuItem workspace={workspace} id={id}/>
			<OpenInC8MenuItem id={id}/>
		</Fragment>}

		<FilterForCatalogFieldValue field={field.field} value={data} />
		<GroupByThisCatalogFieldMenuItem field={field.field} />

	</CatalogItemPreviewMenuItem>)
})

const GroupBySpecInlinePreviewMenuItems = observer(function GroupBySpecInlinePreviewMenuItems() {
	return <GroupTitleSubmenu contents='card'/>
})

const GroupByGroupActiveContextMenuItems = observer(function GroupByGroupActiveContextMenuItems() {
	const {strings, grouping} = useGroupByGroupStore(),
		groupByDropdownStore = useVipLocalStore((ws) => new GroupByDropdownStore(ws,{level: grouping.level, group: grouping}, 'contextMenu'))

	return <GroupByDropdownStoreContext.Provider value={groupByDropdownStore}>
		<ToggleExpandGroup/>
		<ToggleExpandChildrenGroups/>
		<NewCatalogItemSubmenu/>

		<MenuDivider/>

		{/*<ChangeGroupContextMenuItem/>*/}
		{/*<MenuDivider />*/}
		<GroupSubtitlesContextMenuItem group={grouping}/>
		<ChooseSubgroupSubmenu/>
		<ChooseSwatchesSubmenuItem/>
		{/*<ClearHierarchyMenuItem/>*/}
	</GroupByDropdownStoreContext.Provider>
})
const ToggleExpandGroup = observer(function ToggleExpandGroup() {
  const {strings, isExpanded, onToggleExpandCollapse} = useGroupByGroupStore()

  return <ContextMenuItem icon={isExpanded ? icons.collapse : icons.expand} text={isExpanded ? strings.collapseGroups : strings.expandGroups} onClick={onToggleExpandCollapse}/>
})

const ToggleExpandChildrenGroups = observer(function ToggleExpandChildrenGroups() {
  const {strings, hasChildGroup, childGroupStore} = useGroupByGroupStore()

  if (!hasChildGroup) return null

  return (
    <Fragment>
      {!childGroupStore.isExpandedAll && <ContextMenuItem icon={icons.expandAll} text={`${strings.expandAll} Children`} onClick={childGroupStore.expandAllChildren}/>}
      {childGroupStore.isExpandedAll && <ContextMenuItem icon={icons.collapseAll} text={`${strings.collapseAll} Children`} onClick={childGroupStore.collapseAllChildren}/>}
    </Fragment>
  )
})

/*
<TargetsToolbar />
<ToggleAggregationDetails />
 */


// WEBPACK FOOTER //
// ./src/modules/contextMenus/menus/GroupByGroupContextMenu.tsx